import { ImportFilterSet } from './filters'

export type ImportPageState = {
  count: number
  page: number
  perPage: number
  loading: boolean
  shouldFetchList: boolean
  filterSet: ImportFilterSet
}

export type ImportStatus =
  | 'NotStarted'
  | 'Processing'
  | 'CompletedWithErrors'
  | 'Completed'
  | 'Copying Data'
  | 'Finishing'
  | 'Failed'

export interface IImport {
  createdById: string
  createdByName: string
  createdDate: Date
  description: string
  downloadUrl: string
  entityType: string
  id: number
  importId: string
  name: string
  fileName: string
  status: ImportStatus
  totalRecords: number
  progressPercentage: number
}

export const defaultOrderBy = 'createdDate desc'

export const defaultFilters: ImportFilterSet = {
  appliedCount: 0,
  normalizedFilters: [],
  orderBy: defaultOrderBy,
  filters: {},
}
